/**
 * Fire & Flame cart behaviour:
 * - cart updates continue to refresh the cart UI and badge
 * - adding a product never opens the cart drawer automatically
 * - the customer can still open the drawer deliberately through the cart icon
 */

let actionsConfigured = false;
let manualCartDrawerOpenUntil = 0;

const markManualCartDrawerOpen = (event) => {
  if (!event.isTrusted) return;

  const trigger = event.target instanceof Element
    ? event.target.closest('[aria-controls="cart-drawer"], [data-testid="cart-drawer-trigger"]')
    : null;

  if (trigger) {
    manualCartDrawerOpenUntil = Date.now() + 1500;
  }
};

document.addEventListener('click', markManualCartDrawerOpen, true);

function configureStandardActions() {
  const actions = window.Shopify?.actions;
  if (!actions?.updateCart?.configure || !actions?.openCart?.configure) return false;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {},
  });

  actionsConfigured = true;
  return true;
}

function keepConfiguringStandardActions(attempt = 0) {
  if (configureStandardActions()) return;
  if (attempt >= 120) return;

  window.setTimeout(() => keepConfiguringStandardActions(attempt + 1), 100);
}

function installCartDrawerGuard() {
  const drawer = document.querySelector('theme-drawer#cart-drawer');
  if (!drawer || drawer.dataset.ffManualOpenGuard === 'true' || typeof drawer.open !== 'function') return;

  drawer.dataset.ffManualOpenGuard = 'true';

  const originalOpen = drawer.open.bind(drawer);
  const originalClose = typeof drawer.close === 'function' ? drawer.close.bind(drawer) : null;

  drawer.open = (...args) => {
    if (Date.now() > manualCartDrawerOpenUntil) return;
    return originalOpen(...args);
  };

  const preventProgrammaticOpen = () => {
    if (!drawer.hasAttribute('open') || Date.now() <= manualCartDrawerOpenUntil) return;
    originalClose?.();
  };

  drawer.addEventListener('theme-drawer:open', preventProgrammaticOpen);

  const observer = new MutationObserver(preventProgrammaticOpen);
  observer.observe(drawer, { attributes: true, attributeFilter: ['open'] });
}

function initialize() {
  if (!actionsConfigured) {
    keepConfiguringStandardActions();
  } else {
    configureStandardActions();
  }

  customElements.whenDefined('theme-drawer').then(installCartDrawerGuard);
}

initialize();
document.addEventListener('DOMContentLoaded', initialize, { once: true });
document.addEventListener('shopify:section:load', initialize);
window.addEventListener('pageshow', initialize);
